<ng-container *transloco="let t">
	<eventlyte-registration-stepper-progress
		[currentStep]="AppRoutePaths.RegistrationInformation"
		[steps]="getSteps()"
		[maxStepReached]="maxStepReached" />

	<p class="title is-4 pb-1 mb-1">{{ t('content.steps.personalInfo') }}</p>

	<div class="content">
		<p>{{ t('content.pages.registrationInformation.instructions') }}</p>
	</div>

	<div class="fixed-grid has-1-cols-mobile has-2-cols-tablet is-gapless">
		<div class="grid is-gapless is-gap-1">
			<div class="cell is-flex">
				<div class="is-inline-block mr-2" style="max-width: 110px">
					<eventlyte-dropdown-field
						formKey="salutation"
						[formGroup]="formGroup"
						[label]="t('fields.salutation.label')"
							[value]="getRecordValue(record, 'salutation')"
						(valueChange)="setRecordValue(record, 'salutation', $event)"
						[editing]="true"
						placeholder=" "
					>
						<eventlyte-tag-field
							value="Mr"
							[label]="t('fields.salutation.options.Mr')"
							[hasExtraText]="false"
						/>
						<eventlyte-tag-field
							value="Miss"
							[label]="t('fields.salutation.options.Miss')"
							[hasExtraText]="false"
						/>
						<eventlyte-tag-field
							value="Ms"
							[label]="t('fields.salutation.options.Ms')"
							[hasExtraText]="false"
						/>
						<eventlyte-tag-field
							value="Dr"
							[label]="t('fields.salutation.options.Dr')"
							[hasExtraText]="false"
						/>
					</eventlyte-dropdown-field>

				</div>
				<div class="is-flex-grow-1">
					<eventlyte-text-field
						formKey="firstName"
						[formGroup]="formGroup"
						[label]="t('fields.firstName.label')"
							[editing]="true"
						[value]="getRecordValue(record, 'firstName')"
						(valueChange)="setRecordValue(record, 'firstName', $event)" />

				</div>
			</div>
			<div class="cell">
				<eventlyte-text-field
					formKey="lastName"
					[formGroup]="formGroup"
					[label]="t('fields.lastName.label')"
						[editing]="true"
					[value]="getRecordValue(record, 'lastName')"
					(valueChange)="setRecordValue(record, 'lastName', $event)" />

			</div>
			<div class="cell">
				<eventlyte-text-field
					formKey="companyName"
					[formGroup]="formGroup"
					[label]="t('fields.companyName.label')"
						[editing]="true"
					[value]="getRecordValue(record, 'companyName')"
					(valueChange)="setRecordValue(record, 'companyName', $event)" />

			</div>
			<div class="cell">
				<eventlyte-text-field
					formKey="jobTitle"
					[formGroup]="formGroup"
					[label]="t('fields.jobTitle.label')"
						[editing]="true"
					[value]="getRecordValue(record, 'jobTitle')"
					(valueChange)="setRecordValue(record, 'jobTitle', $event)" />

			</div>
			<div class="cell">
				<eventlyte-registration-country-field
					formKey="placeOfResidence"
					[formGroup]="formGroup"
					[label]="t('fields.placeOfResidence.label')"
						[placeholder]="t('fields.placeOfResidence.label')"
					[editing]="true"
					[value]="getRecordValue(record, 'placeOfResidence')"
					(valueChange)="setRecordValue(record, 'placeOfResidence', $event)"
					[highlighted]="['HK', 'CN']"
				/>

			</div>
			<div class="cell">
				<eventlyte-registration-phone-number-field
					formKey="mobileNumber"
					[formGroup]="formGroup"
					[label]="t('fields.mobileNumber.label')"
						[editing]="true"
					[countryLocked]="true"
					[value]="getRecordValue(record, 'mobileNumber')"
					(valueChange)="setRecordValue(record, 'mobileNumber', $event)"
					[highlighted]="['HK', 'CN']"
				/>

			</div>
			<div class="cell">
				<eventlyte-email-field
					formKey="emailAddress"
					[formGroup]="formGroup"
					[label]="t('fields.emailAddress.label')"
						[editing]="true"
					[value]="getRecordValue(record, 'emailAddress')"
					(valueChange)="setRecordValue(record, 'emailAddress', $event)"
				/>


				<div class="has-text-weight-normal is-info is-size-6 message message-body p-2">
					{{ t('content.fields.emailAddressInfo') }}
				</div>
			</div>
			<div class="cell">
				<eventlyte-email-field
					formKey="confirmEmailAddress"
					[formGroup]="formGroup"
					[label]="t('content.fields.confirmEmailAddress.label')"
					[editing]="true"
					[value]="getRecordValue(record, 'confirmEmailAddress')"
					(valueChange)="setRecordValue(record, 'confirmEmailAddress', $event)" />
			</div>
		</div>
	</div>

	<div class="mb-5 mt-0 pt-0">
		<eventlyte-tag-list-field
			formKey="languageForCommunications"
			[formGroup]="formGroup"
			[label]="t('fields.languageForCommunications.label')"
				[value]="getRecordValue(record, 'languageForCommunications')"
			(valueChange)="setRecordValue(record, 'languageForCommunications', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="English"
				[label]="t('fields.languageForCommunications.options.English')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Chinese"
				[label]="t('fields.languageForCommunications.options.Chinese')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<div class="title is-5 is-strong mb-5 mt-0 pt-0">
		{{ t('content.pages.registrationInformation.privacyTitle') }}
	</div>

	<div class="mb-3">
		<eventlyte-checkbox-field
			formKey="bgovPrivacy1"
			[formGroup]="formGroup"
			[label]="t('fields.bgovPrivacy1.label')"
				[value]="getRecordValue(record, 'bgovPrivacy1')"
			(valueChange)="setRecordValue(record, 'bgovPrivacy1', $event)"
			[editing]="true"
		/>

		<a
			href="https://www.aipluspower.com/termsandconditions"
			style="margin-left: 20px"
			target="_blank"
			>https://www.aipluspower.com/termsandconditions</a
		>
	</div>

	<div class="mb-3">
		<eventlyte-checkbox-field
			formKey="bgovPrivacy3"
			[formGroup]="formGroup"
			[label]="t('fields.bgovPrivacy3.label')"
				[value]="getRecordValue(record, 'bgovPrivacy3')"
			(valueChange)="setRecordValue(record, 'bgovPrivacy3', $event)"
			[editing]="true"
		/>

	</div>

	<div class="mb-3">
		<eventlyte-checkbox-field
			formKey="bgovAcceptDataSharingNotice"
			[formGroup]="formGroup"
			[label]="t('fields.bgovAcceptDataSharingNotice.label')"
				[value]="getRecordValue(record, 'bgovAcceptDataSharingNotice')"
			(valueChange)="setRecordValue(record, 'bgovAcceptDataSharingNotice', $event)"
			[editing]="true"
		/>

	</div>

	<div class="subtitle is-6 has-text-weight-bold mt-5 mb-2">
		{{ t('content.pages.registrationInformation.dataSharingNoticeTitle') }}
	</div>

	<div class="message">
		<div class="message-body">
			{{ t('content.pages.registrationInformation.dataSharingNotice') }}
		</div>
	</div>

	<eventlyte-registration-stepper-controls
		[currentStep]="AppRoutePaths.RegistrationInformation"
		[steps]="getSteps()"
		(startAgain)="startAgain()"
		(submitClick)="continue()"
		[processing]="saving()" />

	@if (showFormErrors()) {
		<eventlyte-registration-form-errors-modal
			[(active)]="showFormErrors"
			[formGroups]="validationFormGroups!" />
	}

	@if (showServerErrors()) {
		<eventlyte-registration-server-errors-modal
			[(active)]="showServerErrors"
			[errorList]="serverErrorList()" />
	}
</ng-container>
